import React, { ChangeEvent, useState } from "react";
import styles from "./index.module.scss";
import { Link, useHistory } from "react-router-dom";
import Sound from "react-sound";
import { Button, InputField, Label } from "../../components";
import { v4 as uuidV4 } from "uuid";

function Login() {
  const [state, setState] = useState({
    multiPlayer: false,
    singlePlayer: false,
    createGame: false,
    joinGame: false,
    enterCode: "",
  });

  const { createGame, joinGame, multiPlayer, singlePlayer, enterCode } = state;

  const history = useHistory();

  const handleChange =
    (name: string) => (event: ChangeEvent<HTMLInputElement>) => {
      setState({ ...state, [name]: event.target.value });
    };

  return (
    <div className={styles.heroContainer}>
      <Sound url={"bgm.mp3"} playStatus={"PLAYING"} volume={100} loop={true} />
      <div className={styles.homeContainer}>
        <Button
          name={"Multi Player"}
          disabled={multiPlayer}
          onClick={() => {
            setState({
              ...state,
              multiPlayer: true,
              singlePlayer: false,
              createGame: false,
              joinGame: false,
            });
          }}
        />
        <Button
          name={"Single Player"}
          disabled={singlePlayer}
          onClick={() => {
            setState({
              ...state,
              singlePlayer: true,
              multiPlayer: false,
              createGame: false,
              joinGame: false,
            });
          }}
        />
        {multiPlayer && (
          <div>
            <br />
            <Button
              name={"Create Game"}
              disabled={createGame}
              onClick={() => {
                const code = uuidV4().substr(0, 8);

                setState({ ...state, createGame: true, joinGame: false });
                history.push(`/loading/${code}`);
                // socket.emit(
                //   "join",
                //   {
                //     name: "Swapnadeep",
                //     room: code,
                //   },
                //   (data: any) => {
                //     console.log(data);
                //   }
                // );
                // socket.on("notification", (data) => {
                //   console.log("SOCKET", data);
                // });
              }}
            />
            <Button
              name={"Join Game"}
              disabled={joinGame}
              onClick={() => {
                setState({ ...state, createGame: false, joinGame: true });
              }}
            />
          </div>
        )}
        {singlePlayer && (
          <div>
            <br />
            <Link to="/game">
              <Button name={"Start Game"} />
            </Link>
          </div>
        )}
        {joinGame && (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <br />
            <Label text={"Enter Game Code"} />
            <InputField
              value={enterCode}
              changeHandler={handleChange("enterCode")}
              placeholder="Code"
              type="text"
            />
            {/* <Link to={enterCode ? `/loading/${enterCode}` : "/login"}> */}
            <Button
              name={"Join"}
              onClick={() => {
                if (enterCode) {
                  history.push(`/loading/${enterCode}`);
                  // socket.on("notification", (data) => {
                  //   console.log("SOCKET", data);
                  // });
                }
              }}
            />
            {/* </Link> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
